webpackJsonp([9],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// create project to send to firebase

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      switch1: false,
      switch3: false,
      title: '',
      description: '',
      isUpdating: false,
      date1: new Date().trim,
      date2: new Date().trim,
      user: {},
      users: [],
      searchText: '',
      isContact: false,
      isPending: false,
      contacts: [],
      contactNames: [],
      next: false,
      dialog: false,
      selected: null
    };
  },

  watch: {
    selectedContact: function selectedContact() {
      console.log('hola');
    },
    items: function items() {
      console.log('hi');
    },
    selected: function selected() {}
  },
  computed: {
    filteredUsers: function filteredUsers() {
      var _this = this;

      this.something();
      return this.users.filter(function (user) {
        return user.name.toLowerCase().match(_this.searchText.toLowerCase());
      });
    }
  },
  components: {},
  methods: {
    Cancel: function Cancel() {
      this.reset();
      this.$emit('cancel');
    },
    reset: function reset() {
      this.switch1 = false;
      this.switch3 = false;
      this.isUpdating = false;
      this.date1 = new Date().trim;
      this.date2 = new Date().trim;
      this.user = {};
      this.users = [];
      this.searchText = '';
      this.isContact = false;
      this.isPending = false;
      this.contacts = [];
      this.contactNames = [];
      this.next = false;
      this.dialog = false;
      this.selected = null;
      this.title = '';
      this.description = '';
    },
    draft: function draft() {
      console.log('at least one');
    },
    submit: function submit() {
      if (document.getElementById('title').value === '' || document.getElementById('desc').value === '' || this.switch1 === true && (this.date1 === null || this.date2 === null)) {
        console.log('ISSUE');
        return;
      }
      var members = this.selected == null ? [] : this.selected;
      var project = {
        'title': document.getElementById('title').value,
        'description': document.getElementById('desc').value,
        'dates': true,
        'endDate': this.switch1 ? this.date2 : 0,
        'startDate': this.switch1 ? this.date1 : 0,
        'members': members,
        'creator': this.$store.getters.user,
        'files': []
      };
      this.$store.dispatch('CreateProject', project);
      for (var i = 0; i < members.length; i++) {
        var timestamp = new Date().getTime();
        var user = this.filteredUsers.filter(function (user) {
          return user.id === members[i];
        });
        if (user[0] != null) {
          var notification = {
            message: this.$store.getters.user.name + ' has added you to a project: ' + project.title,
            senderID: this.$store.getters.user.id,
            senderName: this.$store.getters.user.name,
            receiverID: user[0].id,
            receiverName: user[0].name,
            read: false,
            accepted: null,
            type: 'ProjectAdd',
            timestamp: timestamp
          };
          this.$store.dispatch('sendNotification', notification);
        }
      }
      this.reset();
      this.$emit('new', project);
    },
    selectableDays: function selectableDays(date) {
      if (date >= this.date1) {
        return -1;
      }
    },
    something: function something() {
      for (var i = 0; i < this.users.length; i++) {
        if (this.contactNames.includes(this.users[i].id)) {
          this.users[i].group = 'CONNECTED';
        }
      }
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).get().then(function (doc) {
      var user = {
        'id': doc.id,
        'name': doc.data().name
      };
      _this2.user = user;
    }).then(function () {
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(_this2.user.id).collection('contacts').where('accepted', '==', true).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          _this2.contacts.push(doc.data());
          _this2.contactNames.push(doc.data().contactID);
        });
      }).catch(function (error) {
        console.log('Error getting documents: ', error);
      });
    });
    __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var user = {
          'id': doc.id,
          'name': doc.data().name,
          'email': doc.data().email,
          'bio': doc.data().bio,
          'photoURL': doc.data().photoURL,
          'contacts': doc.data().contacts,
          'group': 'not connected'
        };
        if (user.name != null && user.id !== _this2.user.id) {
          _this2.users.push(user);
        }
      });
    });
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', [_c('v-flex', [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-card-text', [
    [_c('v-form', [_c('v-text-field', {
      attrs: {
        "label": "Title",
        "required": "",
        "id": "title"
      },
      model: {
        value: (_vm.title),
        callback: function($$v) {
          _vm.title = $$v
        },
        expression: "title"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Description",
        "required": "",
        "id": "desc"
      },
      model: {
        value: (_vm.description),
        callback: function($$v) {
          _vm.description = $$v
        },
        expression: "description"
      }
    })], 1), _vm._v(" "), _c('v-switch', {
      attrs: {
        "label": "Turn on Dates"
      },
      model: {
        value: (_vm.switch1),
        callback: function($$v) {
          _vm.switch1 = $$v
        },
        expression: "switch1"
      }
    }), _vm._v(" "), _c('v-layout', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.switch1),
        expression: "switch1"
      }],
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "120%"
      }
    }, [_vm._v(" Start Date ")]), _vm._v(" "), _c('v-date-picker', {
      model: {
        value: (_vm.date1),
        callback: function($$v) {
          _vm.date1 = $$v
        },
        expression: "date1"
      }
    })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.switch1),
        expression: "switch1"
      }],
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "120%"
      }
    }, [_vm._v(" End Date ")]), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "allowed-dates": _vm.selectableDays
      },
      model: {
        value: (_vm.date2),
        callback: function($$v) {
          _vm.date2 = $$v
        },
        expression: "date2"
      }
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-switch', {
      attrs: {
        "label": "Add Team Members"
      },
      model: {
        value: (_vm.switch3),
        callback: function($$v) {
          _vm.switch3 = $$v
        },
        expression: "switch3"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.switch3),
        expression: "switch3"
      }]
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "disabled": _vm.isUpdating,
        "items": _vm.filteredUsers,
        "box": "",
        "chips": "",
        "color": "blue-grey lighten-2",
        "label": "Select Team Members",
        "item-text": "name",
        "item-value": "id",
        "cache-items": "",
        "multiple": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected,
              "close": ""
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item.id)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.photoURL
            }
          })]), _vm._v("\n                  " + _vm._s(data.item.name) + "\n                ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.photoURL
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.name)
            }
          }), _vm._v(" "), _c('v-list-tile-sub-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.group)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })], 1)], 1)]
  ], 2), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.draft
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.Cancel
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.c3605e9e2bf42ec717df.js